import { Spacing } from '@billy/design-system'

export const PANEL_HORIZONTAL_PADDING = Spacing.S32
